'use client'
import { useRouter } from 'next/navigation'
import type { FC } from 'react'
import { Trans } from 'react-i18next'
import configuration from '~/configuration'
import { TypographyText } from '~/core/ui/Text'
import type { INotification, INotificationJob } from '~/lib/features/notifications/types'
import NotificationItemLayout from './NotificationItemLayout'

const SystemAutoCloseJobApplications: FC<{
  notification: INotification
  onClick: () => void
  onDelete: () => void
  isLoadingDeleted: boolean
}> = ({ notification, onClick, onDelete, isLoadingDeleted }) => {
  const propertiesRelated = notification?.payload as INotificationJob
  const router = useRouter()
  return (
    <NotificationItemLayout
      onDelete={onDelete}
      isLoadingDeleted={isLoadingDeleted}
      user={notification.user}
      actionType={notification.actionType}
      readAt={notification.readAt}
      createdAt={notification.createdAt}>
      {({ time }) => (
        <TypographyText
          className="cursor-pointer text-sm text-gray-700"
          onClick={() => {
            router.push(configuration.path.jobs.detail(propertiesRelated.jobId))
            onClick && onClick()
          }}>
          <Trans
            i18nKey="activity:notification:systemAutoCloseJobApplications"
            values={{
              jobTitle: propertiesRelated?.jobTitle
            }}>
            <span className="font-medium text-gray-900" />
          </Trans>
          {time}
        </TypographyText>
      )}
    </NotificationItemLayout>
  )
}

export default SystemAutoCloseJobApplications
